import React, { PureComponent } from 'react';
import { Route, Redirect, Switch } from 'dva/router';
import PageHeaderLayout from 'layouts/PageHeaderLayout';
import { getRoutes } from 'utils/utils.js';
import NotFound from '../../../Exception/404';

export default class Layout extends PureComponent {
  render() {
    const { match, routerData } = this.props;

    return (
      <PageHeaderLayout tabActiveKey={location.pathname}>
        <Switch>
          {getRoutes(match.path, routerData).map(item => (
            <Route key={item.key} path={item.path} component={item.component} exact={item.exact} />
          ))}
          <Redirect exact from="/merchant/business/my" to="/merchant/business/my/base-info" />
          <Route render={NotFound} />
        </Switch>
      </PageHeaderLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Layout.js